import { Alert } from "antd";

function NotFoundError({ title, description }) {
    return <Alert title={title} description={description} type="error" showIcon />;
}

export default NotFoundError;
